/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPolygon = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5.444 2 1 12l4.444 10h13.3L23 12 18.744 2zM3.189 12l3.555-8h10.7L21 12l-3.556 8h-10.7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPolygon as Polygon };
